export const getMadiranData = () => ({
  name: "Madiran",
  region: "Sud-Ouest",
  country: "France",
  description: "Madiran est une appellation prestigieuse du Sud-Ouest de la France, célèbre pour ses vins rouges puissants et tanniques élaborés principalement à partir du cépage Tannat. Cette région produit des vins de garde exceptionnels.",
  type: "subregion",
  area: "1,600 ha",
  production: "80,000 hectolitres",
  mapAreas: [
    { region: "Madiran", x: -0.1, y: 43.5, color: "#4B164C", size: 3 }
  ],
  characteristics: {
    climate: "Climat océanique tempéré, étés chauds, hivers doux",
    soil: "Sols d'argile et de calcaire, excellente structure",
    viticulture: "Viticulture traditionnelle, vendanges manuelles"
  },
  wineStyles: {
    red: "Vins rouges puissants et structurés, avec des tanins fermes et une excellente concentration",
    white: "Vins blancs secs et aromatiques, avec une belle acidité"
  },
  history: "La viticulture à Madiran remonte à l'époque romaine. Le cépage Tannat est devenu le cépage emblématique de la région. Au XIXe siècle, les vins de Madiran étaient très appréciés. Aujourd'hui, Madiran est reconnue pour ses vins de qualité et son identité terroir unique.",
  foodPairing: "Cuisine du Sud-Ouest, viandes rouges, gibier, fromages affinés, confit de canard",
  grapeVarieties: [
    {
      name: "Tannat",
      percentage: "60%",
      description: "Cépage emblématique de Madiran, produisant des vins puissants et tanniques",
      characteristics: "Puissant, tanins très fermes, fruits noirs, épices",
      wineStyles: "Sec, plein-corps, très tannique"
    },
    {
      name: "Cabernet Franc",
      percentage: "25%",
      description: "Cépage d'assemblage, apportant élégance et aromatique",
      characteristics: "Élégant, aromatique, tanins fins",
      wineStyles: "Sec, moyen-corps, aromatique"
    },
    {
      name: "Cabernet Sauvignon",
      percentage: "15%",
      description: "Cépage d'assemblage, apportant structure et tanins",
      characteristics: "Structuré, tanins fermes, notes de cassis",
      wineStyles: "Sec, plein-corps, tannique"
    }
  ],
  subregions: {
    "madiran-central": {
      name: "Madiran Central",
      description: "Zone centrale de l'appellation, produisant les vins les plus prestigieux",
      characteristics: {
        climate: "Climat optimal, exposition sud",
        soil: "Sols argilo-calcaires",
        viticulture: "Viticulture traditionnelle"
      },
      grapeVarieties: {
        red: ["Tannat", "Cabernet Franc", "Cabernet Sauvignon"]
      },
      wineStyles: {
        red: "Vins rouges de garde, complexes et structurés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés"
    },
    "madiran-peripherique": {
      name: "Madiran Périphérique",
      description: "Zone périphérique, produisant des vins plus accessibles",
      characteristics: {
        climate: "Climat légèrement plus frais",
        soil: "Sols variés",
        viticulture: "Viticulture moderne"
      },
      grapeVarieties: {
        red: ["Tannat", "Cabernet Franc"]
      },
      wineStyles: {
        red: "Vins rouges fruités et accessibles"
      },
      foodPairing: "Viandes blanches, charcuterie, fromages"
    }
  }
}); 